import "./shared/modernizr.js";
import "./mobx.config";

import React from "react";
import ReactDOM from "react-dom";

import registerServiceWorker from "./registerServiceWorker";
import "./index.scss";
import { extendConfig } from "./config";

import App from "./App";
import "@fontsource/open-sans";
window.process = window.process || {};

fetch(configPath())
  .then((res) => {
    res
      .json()
      .then(extendConfig)
      .then(() => {
        ReactDOM.render(<App />, document.getElementById("airstrip-root"));
      })
      .catch((err) => console.error("error loading JSON config", err));
  })
  .catch((err) => console.error("error loading JSON config", err));

registerServiceWorker();

function configPath() {
  if (process.env.NODE_ENV === "development" && localStorage.configPath) {
    return localStorage.configPath;
  }

  return (
    document.querySelector('link[rel="airstrip-config"]')?.href || "config.json"
  );
}
